/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { NumericTrackItDataTypeFilterDtoDataType } from './NumericTrackItDataTypeFilterDtoDataType';
import {
    NumericTrackItDataTypeFilterDtoDataTypeFromJSON,
    NumericTrackItDataTypeFilterDtoDataTypeFromJSONTyped,
    NumericTrackItDataTypeFilterDtoDataTypeToJSON,
} from './NumericTrackItDataTypeFilterDtoDataType';

/**
 * 
 * @export
 * @interface NumericTrackItDataTypeFilterDto
 */
export interface NumericTrackItDataTypeFilterDto {
    /**
     * 
     * @type {string}
     * @memberof NumericTrackItDataTypeFilterDto
     */
    id: string;
    /**
     * 
     * @type {NumericTrackItDataTypeFilterDtoDataType}
     * @memberof NumericTrackItDataTypeFilterDto
     */
    dataType?: NumericTrackItDataTypeFilterDtoDataType | null;
    /**
     * 
     * @type {string}
     * @memberof NumericTrackItDataTypeFilterDto
     */
    $type?: NumericTrackItDataTypeFilterDtoTypeEnum;
}


/**
 * @export
 */
export const NumericTrackItDataTypeFilterDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoNumericTrackItDataTypeFilterDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.NumericTrackItDataTypeFilterDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type NumericTrackItDataTypeFilterDtoTypeEnum = typeof NumericTrackItDataTypeFilterDtoTypeEnum[keyof typeof NumericTrackItDataTypeFilterDtoTypeEnum];



/**
 * Check if a given object implements the NumericTrackItDataTypeFilterDto interface.
 */
export function instanceOfNumericTrackItDataTypeFilterDto(value?: unknown): value is NumericTrackItDataTypeFilterDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(NumericTrackItDataTypeFilterDtoTypeEnum)[0];
}

export function NumericTrackItDataTypeFilterDtoFromJSON(json: any): NumericTrackItDataTypeFilterDto {
    return NumericTrackItDataTypeFilterDtoFromJSONTyped(json, false);
}

export function NumericTrackItDataTypeFilterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumericTrackItDataTypeFilterDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataType': json['dataType'] == null ? undefined : NumericTrackItDataTypeFilterDtoDataTypeFromJSON(json['dataType']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function NumericTrackItDataTypeFilterDtoToJSON(value?: NumericTrackItDataTypeFilterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'dataType': NumericTrackItDataTypeFilterDtoDataTypeToJSON(value['dataType']),
        '$type': value['$type'],
    });
}

